<div class="updated-card mb-2" id="updated-tag-card" data-id="updated-tag-card">
  <div class="updated-tag">Updated</div>
  <div class="updated-label">
    {{ updated }}
  </div>
</div>
